import React from 'react';
import { useLocalizedData } from '../hooks/useTranslatedContent';

const QuoteBlock = ({ aboutData }) => {
    const { getLocalized, getLocalizedFirstItem } = useLocalizedData(aboutData);

    if (!aboutData) return null;

    const title = getLocalized('title');
    const description = getLocalized('description');
    const titleDescItem = getLocalizedFirstItem('titleDescSection');

    return (
        <section className="py-16 px-6 bg-white max-w-7xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-start">
                <div>
                    <h2 className="text-2xl md:text-3xl font-bold text-black">
                        {title || "Our Mission"}
                    </h2>
                </div>
                <div className="text-gray-600 space-y-4 text-base leading-relaxed">
                    {description && (
                        <p dangerouslySetInnerHTML={{
                            __html: description || "We are committed to excellence in everything we do."
                        }} />
                    )}
                </div>
            </div>

            {titleDescItem?.img && (
                <div className="mt-24 flex flex-row items-start gap-9">
                    <img
                        src={titleDescItem.img}
                        alt="Quote Visual"
                        className="w-12 h-12 object-contain"
                    />
                    {titleDescItem.description && (
                        <p
                            className="text-xl font-semibold text-gray-800"
                            dangerouslySetInnerHTML={{
                                __html: titleDescItem.description || "Our vision drives us forward."
                            }}
                        />
                    )}
                </div>
            )}
        </section>
    );
};

export default QuoteBlock;